import type { TCriarAtendimentoResponse } from '@/features/atendimento/interfaces'
import { HttpService } from '@/infra'

export class CriarAtendimentoService extends HttpService {
  async execute(clienteId: string): Promise<TCriarAtendimentoResponse> {
    const response = await this.http.post<TCriarAtendimentoResponse>('api/v2/Atendimento', { clienteId })
    return response.data
  }
}
